import Headline from "@/components/typographie/Headlines/Headline";
import Text from "@/components/typographie/Text/Text";
import React from "react";
import NewsTags from "@/components/ContentElements/News/Text/NewsTags";
import {tv} from "tailwind-variants";
import clsx from "clsx";
import {AssetFields} from "contentful";
import ImageRenderer from "@/libs/contentful/helper/ImageRenderer";
import {formatDate} from "@/libs/helper/helper"

interface Props {
    newsTeaserType: 'newsDetailPage' | 'bigNewsTeaser' | 'smallNewsTeaser'
    headline: string
    contentTags?: string[] | undefined
    contentType: string
    contentTypeIcon: AssetFields
    date: string
}

const generateClasses = tv({
    slots: {
        root: 'pointer-events-none flex flex-col gap-s',
        headlineClassName: 'brand-transition underline decoration-transparent',
        headlineType: '',
        iconClassName: '',
        align: '',
        textWrapper: ''
    },
    variants: {
        newsTeaserType: {
            'newsDetailPage': {
                root: 'gap-xl',
                align: 'center',
                headlineType: 'h1',
                headlineClassName: 'no-underline'
            },
            'bigNewsTeaser': {
                headlineClassName: 'md:underline-offset-4 decoration-2 group-hover/newsTeaser:decoration-black md:group-hover/newsTeaser:decoration-white',
                iconClassName: 'md:invert',
                align: 'center',
                root: 'z-[2] w-fill max-w-[600px] h-[calc(100%-3rem)] flex flex-col justify-end my-mobile sm:my-l sm:mx-auto md:text-white md:absolute md:top-[0] md:right-[0] md:left-[0] brand-transition group-hover/newsTeaser:h-[calc(100%-4rem)]',
                headlineType: 'h2',
            },
            'smallNewsTeaser': {
                headlineClassName: 'group-hover/newsTeaser:decoration-black font-sans font-semibold',
                align: 'start',
                headlineType: 'h3',
            }
        }
    },
});

export default function NewsTextElement({newsTeaserType, headline, contentTags, contentType, contentTypeIcon, date}:Props) {

    const {root, headlineClassName, headlineType, iconClassName, align} = generateClasses({
        newsTeaserType
    });

    return (
        <div className={clsx(root(), 'items-' + align())}>
            {contentTags && <NewsTags contentTags={contentTags} align={align()} />}
            <Headline type={headlineType()} className={headlineClassName()}>{headline}</Headline>
            <div className={"flex items-center gap-s sm:gap-m flex-wrap sm:flex-row justify-" + align()}>
                {contentType && contentTypeIcon.fields && <span className="flex items-center gap-xs">
                    <ImageRenderer image={contentTypeIcon.fields} className={clsx('max-w-[24px] max-h-[24px]' , iconClassName())}/>
                    <Text type="above">{contentType}</Text>
                </span>}
                {contentType && date && <>•</>}
                {date && <Text>{formatDate(date)}</Text>}
            </div>
        </div>
    )
}